import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../../context/ThemeContext";
import UserContext from '../../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import HtlDynPriceGrpDtl from "./HtlDynPriceGrpDtl";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../../lang/LangGlb';




const GET_POST = gql`
query MyQuery(
    $seaId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
      tbl_dyn_price_grp_def_main(where: {dyn_grp_id: {_eq: $seaId}
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
    dyn_grp_id
    firm_main_code
    firm_sub_code
    start_date
    end_date

    dyn_grp_desc
    active

  }
  tbl_dyn_price_grp_def(where: {grp_main_id: {_eq: $seaId}}) {
    id_seq
    grp_main_id
    firm_main_code
    firm_sub_code
    dyn_grp_code
    dyn_grp_percent
    dyn_grp_sup_red_type
    
  }
  
}
`;

const INSERT_SEA = gql`
  mutation InsertSeason(
    $seaId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $seaDesc: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean
   
    
  ) {
    insert_tbl_dyn_price_grp_def_main(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        dyn_grp_id: $seaId,
        dyn_grp_desc: $seaDesc,
        start_date: $startDate,
        end_date: $endDate,
        active: $fmActive

        
      }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_FIRM = gql`
mutation UpdateFirm(
    $seaId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $seaDesc: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean
  ) {
    update_tbl_dyn_price_grp_def_main(
      where: {
        dyn_grp_id: { _eq: $seaId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        dyn_grp_desc: $seaDesc
        active: $fmActive
        start_date: $startDate
        end_date: $endDate
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;






const HtlDynPriceGrp = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { seaId: varCode, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode  },
  });


  const firmData = data && data.tbl_dyn_price_grp_def_main ? data.tbl_dyn_price_grp_def_main[0] : null;
  const firmData2 = data && data.tbl_htl_period ? data.tbl_htl_period[0] : null;
 

  const [updateFirm] = useMutation(UPDATE_FIRM);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("AGN");
  const [place, setPlace] = useState("");
  const [fmActive, setFmActive] = useState(firmData ? firmData.active : false); 
  const [seaDesc, setSeaDesc] = useState(firmData ? firmData.dyn_grp_desc : ""); 
  const [seaId, setSeaId] = useState("");
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);
  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const new_firm = messages[currentLocale].new_firm;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const placerec = messages[currentLocale].placerec;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const per_id_title = messages[currentLocale].per_id_title;
  const per_code_title = messages[currentLocale].per_code_title;
  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const typerec = messages[currentLocale].typerec;


  



  
  const detail = messages[currentLocale].detail;
  
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;


  const dynamic_price_id_title = messages[currentLocale].dynamic_price_id_title;
  const dynamic_price_desc_title = messages[currentLocale].dynamic_price_desc_title;
  const dynamic_price_new_btn = messages[currentLocale].dynamic_price_new_btn;
  const dynamic_price_group_title = messages[currentLocale].dynamic_price_group_title;
  const dynamic_price_group_detail_btn = messages[currentLocale].dynamic_price_group_detail_btn;
  const dynamic_price_group_code_title = messages[currentLocale].dynamic_price_group_code_title;
  const dynamic_price_group_percent_title = messages[currentLocale].dynamic_price_group_percent_title;
  const dynamic_persent_conde_title = messages[currentLocale].dynamic_persent_conde_title;


  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (seaId !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [seaId, setSeaId]);

  useEffect(() => {
    if (firmData) {
  
        setSeaId(firmData.dyn_grp_id);
        setStartDate(new Date(firmData.start_date));
        setEndDate(new Date(firmData.end_date));
        setSeaDesc(firmData.dyn_grp_desc);
        setFmActive(firmData.active);
          
    }
  }, [firmData]);


  const handleUpdate = () => {
   
    
    updateFirm({
      variables: {
        seaId: seaId,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
       
        seaDesc: seaDesc,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        fmActive: fmActive,
        
      },
    })
      .then(() => {
        window.alert("FPrice Group updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setSeaId(updatedIdSeq.toString());  
      setVarCode(updatedIdSeq.toString());  
      console.log(seaId);
     
       
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };

  const handleinser = () => {
    InsertSeason({
      variables: {
    seaId: seaId,
    ownFirmCode: ownFirmCode,
    ownFirmSubCode: ownFirmSubCode,
    seaDesc: seaDesc,
    startDate: new Date(startDate).toLocaleDateString(),
    endDate: new Date(endDate).toLocaleDateString(),
    fmActive: fmActive
    
           
      },
    })
      .then(() => {
        window.alert("Season insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert Season:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
    setVarCode2(0);  
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };




  return (

    <div className="container p-2 mx-auto sm:p-4 ">
      <div className="card  ">
    
     <div className=" p-2 ">
          <div className="pt-1 -my-14 -ml-14 -mr-14  -mb-5"> 
            <Fieldset>
            <p className="my-0  ">

          <div className="flex gap-4">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{dynamic_price_id_title}</label>
    <InputText className="w-full text-base" 
    id="username" value={varCode}
    onChange={(e) => setSeaId(e.target.value)}
    readOnly
    />
  </div>

  <div className="w-4/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{dynamic_price_desc_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={seaDesc} 
    onChange={(e) => setSeaDesc(e.target.value)} autoComplete="off"/>
    
  </div>
 
  </div>

  
  <div className="flex gap-3 my-5">
  
  

  <div className="w-1/3 h-10 gap-3">
        <label                
         htmlFor="firmname"> {start_date_title}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate} dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

      <div className="w-1/3 gap-3">
        <label                
         htmlFor="firmname"> {end_date_title}</label>
        <Calendar className="w-1/8 h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

  <div className=" flex-col font-medium  flex justify-content-center">
  
  <label htmlFor="firmtype" 
  className=" flex-col  ml-0 mb-5 align-items-center block font-medium text-gray-950">{statusrec} </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setFmActive(e.value)} checked={fmActive === true} />
          <label htmlFor="ingredient1" className="ml-2">{activerec}</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setFmActive(e.value)} checked={fmActive === false} />
          <label htmlFor="ingredient2" className="ml-2">{inactiverec}</label>
      </div>
      </div>
      </div>  
      </div>
      <div className="flex  gap-4 ">
      <div className="w-2/4">
     
  </div>
  <div className="w-2/4">
    <Button
      label={dynamic_price_group_detail_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={onClick2}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={dynamic_price_new_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '45vw' }}header={dynamic_price_group_title} onHide={onHide}>
  <p>
   <HtlDynPriceGrpDtl/>
  </p>
</Dialog>
</div>

</p>
    </Fieldset>
        </div>
  
             
        </div>          
       

    
   </div>
  
    <p> <DataTable
         value={data.tbl_dyn_price_grp_def}
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="grp_main_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{dynamic_price_id_title}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
          <Column field="id_seq"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Id"}</span>}
           style={{ textAlign: 'left', width: '8rem' }}
          >
          </Column>

          <Column field="dyn_grp_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{dynamic_price_group_code_title}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>

          <Column field="dyn_grp_percent"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{dynamic_price_group_percent_title}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>

          <Column field="dyn_grp_sup_red_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{dynamic_persent_conde_title}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>

          
          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setVarCode2(rowData.id_seq);  
                setVarCode(rowData.grp_main_id);                          
               onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>
        
     
    </div>

    
    
    
 
 
);
};

export default HtlDynPriceGrp;
